import { useCrm } from './CrmContext';
import { ContactPanel } from './ContactPanel';
import { CompanyPanel } from './CompanyPanel';
import { ContactEditor } from './ContactEditor';
import { ScreenPopStack } from './ScreenPop';

/** App-wide CRM layers: incoming-call pop-ups, and whichever contact or company is open. */
export function CrmOverlays() {
  const { data, focus, closeFocus, openContact } = useCrm();
  if (!data) return null;
  return (
    <>
      <ScreenPopStack />
      {focus?.type === 'contact' && <ContactPanel key={focus.id} contactId={focus.id} onClose={closeFocus} />}
      {focus?.type === 'company' && <CompanyPanel key={focus.id} companyId={focus.id} onClose={closeFocus} />}
      {focus?.type === 'newContact' && <ContactEditor initialPhone={focus.phone} onClose={closeFocus} onSaved={(id) => setTimeout(() => openContact(id), 0)} />}
    </>
  );
}
